import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Constants } from '../../app.constants';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { NsNumberInputConstants } from '../ns-components/ns-number-input/ns-number-input.constants';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-donation-amount-selector',
  templateUrl: './donation-amount-selector.component.html',
  styleUrls: ['./donation-amount-selector.component.scss']
})
export class DonationAmountSelectorComponent implements OnInit, OnDestroy {
  readonly constants = Constants;

  @Input() brandColor?: string;
  @Output() amountSelected$ = new EventEmitter<number>();
  @Output() errorMessageKey$ = new EventEmitter<number>();
  @Output() formValid$ = new EventEmitter<boolean>();

  resetNumberField$: EventEmitter<void> = new EventEmitter();
  amountFormGroup: UntypedFormGroup;
  amountInput: UntypedFormControl = new UntypedFormControl('');
  inputValidators: ValidatorFn[] = [Validators.max(this.constants.MAXIMUM_DONATION_AMOUNT),
    Validators.min(this.constants.MINIMUM_DONATION_AMOUNT), Validators.required];
  private _amountSelected = this.constants.DONATION_AMOUNTS_VALUES[0];
  private isFixedAmount = true;
  activeButtonKey = this.constants.DONATION_AMOUNTS_VALUES[0];
  showContactUs: boolean;
  subscription: Subscription = new Subscription();
  donationInputPlaceholder: string;

  constructor(private formBuilder: UntypedFormBuilder, private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.amountSelected$.emit(this._amountSelected);
    this.amountFormGroup = this.formBuilder.group({
      amount: this.amountInput,
    });
    this.subscription.add(
      this.amountFormGroup.valueChanges.subscribe(() => {
        this.formValid$.next(this.amountFormGroup.valid);
      }));
    this.donationInputPlaceholder = this.translate.instant('DONATION_SELECTOR.other_amount');
  }

  onFreeAmountType(amount: number): void {
    this.amountInput.setValidators(this.inputValidators);
    if (this.isFixedAmount) {
      this.amountInput.updateValueAndValidity();
    }
    this.activeButtonKey = null;
    this._amountSelected = amount;
    this.isFixedAmount = false;
    this.showContactUs = false;
    this.amountSelected$.emit(this._amountSelected);
  }

  onFixedAmountClick(amount: number): void {
    this.amountInput.setValidators([]);
    this.activeButtonKey = amount;
    this._amountSelected = amount;
    this.isFixedAmount = true;
    this.showContactUs = false;
    this.resetNumberField$.emit();
    this.amountInput.reset();
    this.amountSelected$.emit(this._amountSelected);
  }

  onErrorMessageKey(errorKey: number): void {
    this.showContactUs = errorKey === NsNumberInputConstants.MAX_VALUE_EXCEEDED_ERROR_KEY;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
